import React, { Component } from "react";
import { connect } from 'react-redux';
import Loader from "react-loaders";
import axiosInstance from "../configuration/Request";
import { toast, Bounce } from "react-toastify";
import { setloginDetails } from "../../reducers/counterSlice";
import Select from "react-select";
import { Input } from "reactstrap";

const mapStateToProps = (state) => {
    return {
        reduxData: state.counterSlice
    };
};

const mapDispatchToProps = {
    setloginDetails
};

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditMode: false,
            professionTypeOptions: [],
            workOptions: [],
            selectedProfession: null,
            selectedWork: null,
            otherProfession: '',
            otherWork: '',
            loader: false,
        };
    }

    async componentDidMount() {
        await this.fetchOptions();
        this.initializeSelections();
    }

    fetchOptions = async () => {
        this.setState({ loader: true });
        try {
            const [professionsRes, worksRes] = await Promise.all([
                axiosInstance.get(`${process.env.REACT_APP_BASE_URL}api/professions`),
                axiosInstance.get(`${process.env.REACT_APP_BASE_URL}api/works`)
            ]);

            let professionOptions = professionsRes.data.data.map(item => ({
                value: item.id,
                label: item?.attributes?.title
            }));
            professionOptions.push({ value: 0, label: 'Other' });

            let workOptions = worksRes.data.data.map(item => ({
                value: item.id,
                label: item?.attributes?.title
            }));
            workOptions.push({ value: 0, label: 'Other' });

            this.setState({
                professionTypeOptions: professionOptions,
                workOptions: workOptions
            });
        } catch (error) {
            console.error("Failed to fetch options:", error);
        } finally {
            this.setState({ loader: false });
        }
    }

    initializeSelections = () => {
        const user = this.props.reduxData?.loginDetails?.user;
        if (!user) return;

        const { professionTypeOptions, workOptions } = this.state;

        let selectedProfession = professionTypeOptions.find(opt => opt.label === user.profession);
        let otherProfession = '';
        if (!selectedProfession && user.profession) {
            selectedProfession = professionTypeOptions.find(opt => opt.label === 'Other');
            otherProfession = user.profession;
        }

        let selectedWork = workOptions.find(opt => opt.label === user.work);
        let otherWork = '';
        if (!selectedWork && user.work) {
            selectedWork = workOptions.find(opt => opt.label === 'Other');
            otherWork = user.work;
        }

        this.setState({
            selectedProfession,
            otherProfession,
            selectedWork,
            otherWork
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reduxData?.loginDetails?.user !== this.props.reduxData?.loginDetails?.user) {
            this.initializeSelections();
        }
    }

    handleEditToggle = () => {
        this.setState(prevState => ({ isEditMode: !prevState.isEditMode }), () => {
            if (this.state.isEditMode) {
                this.initializeSelections();
            }
        });
    }

    handleSelectChange = (selectedOption, field) => {
        if (field === 'profession') {
            this.setState({ selectedProfession: selectedOption });
        } else {
            this.setState({ selectedWork: selectedOption });
        }
    }

    handleOtherChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSave = async () => {
        const { selectedProfession, otherProfession, selectedWork, otherWork } = this.state;
        const user = this.props?.reduxData?.loginDetails?.user;
        const userId = user?.id;
        const email = user?.email;

        if (!userId || !email) return;

        const finalProfession = selectedProfession?.label === 'Other' ? otherProfession : selectedProfession?.label;
        const finalWork = selectedWork?.label === 'Other' ? otherWork : selectedWork?.label;

        this.setState({ loader: true });

        try {
            // 1. Update user details
            const response = await axiosInstance.put(`${process.env.REACT_APP_BASE_URL}api/users/${userId}`, {
                profession: finalProfession,
                work: finalWork
            });

            if (response.status === 200) {
                // 2. Fetch latest user information
                const updatedUserRes = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}api/users?filters[email][$eq]=${email}`);

                // Handle response format (user mentioned it's an object, but Strapi filters usually return an array)
                const updatedUserData = Array.isArray(updatedUserRes.data) ? updatedUserRes.data[0] : updatedUserRes.data;

                if (updatedUserData) {
                    // 3. Update Redux store to sync sidebar and other components
                    const newLoginDetails = {
                        ...this.props.reduxData.loginDetails,
                        user: updatedUserData
                    };
                    this.props.setloginDetails(newLoginDetails);

                    toast("Profile updated successfully!", {
                        transition: Bounce,
                        closeButton: true,
                        autoClose: 3000,
                        position: "top-right",
                        type: "success",
                    });

                    this.setState({ isEditMode: false });
                }
            }
        } catch (error) {
            console.error("Failed to update profile:", error);
            toast("Failed to update profile. Please try again.", {
                transition: Bounce,
                type: "error",
            });
        } finally {
            this.setState({ loader: false });
        }
    }

    render() {
        const { isEditMode, professionTypeOptions, workOptions, selectedProfession, selectedWork, otherProfession, otherWork, loader } = this.state;
        const user = this.props?.reduxData?.loginDetails?.user || {};

        return (
            <div className="profile-container">
                <div className="profile-header">
                    <div className="profile-title-group">
                        <h2>Profile</h2>
                        <p>View and manage your personal information.</p>
                    </div>
                    {!isEditMode && (
                        <div className="edit-profile-action">
                            <button onClick={this.handleEditToggle}>Edit profile</button>
                        </div>
                    )}
                </div>

                <hr />

                <div className="account-details-section">
                    <span className="section-label">Account details</span>

                    <div className="details-grid">
                        <div className="detail-label">Name</div>
                        <div className="detail-value">{user.username || 'N/A'}</div>

                        <div className="detail-label">Email</div>
                        <div className="detail-value">{user.email || 'N/A'}</div>

                        <div className="detail-label">Profession</div>
                        <div className="detail-value">
                            {isEditMode ? (
                                <div className="w-100">
                                    <Select
                                        options={professionTypeOptions}
                                        value={selectedProfession}
                                        onChange={(opt) => this.handleSelectChange(opt, 'profession')}
                                        placeholder="Select Profession"
                                        className="mb-2"
                                        isSearchable={false}
                                    />
                                    {selectedProfession?.label === 'Other' && (
                                        <Input
                                            type="text"
                                            name="otherProfession"
                                            value={otherProfession}
                                            onChange={this.handleOtherChange}
                                            placeholder="Enter Profession Manually"
                                        />
                                    )}
                                </div>
                            ) : (
                                user.profession || 'N/A'
                            )}
                        </div>

                        <div className="detail-label">Work</div>
                        <div className="detail-value">
                            {isEditMode ? (
                                <div className="w-100">
                                    <Select
                                        options={workOptions}
                                        value={selectedWork}
                                        onChange={(opt) => this.handleSelectChange(opt, 'work')}
                                        placeholder="Select Work"
                                        className="mb-2"
                                        isSearchable={false}
                                    />
                                    {selectedWork?.label === 'Other' && (
                                        <Input
                                            type="text"
                                            name="otherWork"
                                            value={otherWork}
                                            onChange={this.handleOtherChange}
                                            placeholder="Enter Work Manually"
                                        />
                                    )}
                                </div>
                            ) : (
                                user.work || 'N/A'
                            )}
                        </div>
                    </div>

                    {isEditMode && (
                        <div className="save-btn-container">
                            <button className="save-btn" onClick={this.handleSave} disabled={loader}>
                                Save
                            </button>
                        </div>
                    )}
                </div>

                {loader && (
                    <div className="backdrop">
                        <div className="loader">
                            <Loader type="ball-pulse-rise" />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
